import toastr from "toastr";

toastr.options = {
  "positionClass": "toast-top-center"
};
